import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import PaginationSelector from '../SearchBar/PaginationSelector'
import SortingSelector from '../SearchBar/SortingSelector'
import PropertyListings from './PropertyListings'
import ListingsHeader from './ListingsHeader'
import { isEmpty } from '../../../lib/utils/collection'

const ListingGroup = ({ isLoading, header, isSortingOn, totalListings, listings, markListingAsSaved }) => {
  return (
    <section className={cn('ListingGroup', { 'ListingGroup-disabled': isLoading && !isEmpty(listings)})}>
      <header className='ListingGroup-heading ListingGroup-fullWidth'>
        <ListingsHeader heading={header} totalCount={totalListings} />

        <div className='ListingGroup-searchToolsContent'>
          {isSortingOn && (
            <div className='ListingGroup-searchTools'>
              <SortingSelector />
            </div>
          )}
        </div>
      </header>

      <PropertyListings listings={listings} markListingAsSaved={markListingAsSaved} />

      <div className='ListingGroup-footer'>
        <div className='ListingGroup-footerBlock ListingGroup-footerBlock--withoutBorder'>
          <PaginationSelector />
        </div>
      </div>
    </section>
  )
}

ListingGroup.propTypes = {
  isLoading: PropTypes.bool,
  header: PropTypes.string,
  totalListings: PropTypes.number,
  isSortingOn: PropTypes.bool,
  listings: PropTypes.array,
  markListingAsSaved: PropTypes.func
}

export default ListingGroup
